var exports = {
  "k": "DisableInvitesButton.module__container___RG1lQn",
  "i": "DisableInvitesButton.module__message___RG1lQn",
};

module.exports = exports;
